import apiGuard from "../../../context-controller-mod/context-serv/global-provider/api-shell/api-gaurd";

const ApiPost = <T = unknown>(
  url: string,
  data?: unknown,
  responseType: "json" | "blob" = "json"
) => {
  return apiGuard.post<T>(url, data,{ responseType });
};

export default ApiPost;
